import { environment } from "src/environments/environment"

export class urls {
    static SERVER_URL = environment.baseUrl
    static API_URL = environment.baseUrl + 'api/v1/'  
    // User
    static SIGNIN_URL = 'auth/login'
    static FORGOT_URL = 'auth/forgot'
    static PROFILE_URL = 'auth/me'
    static REFRESH_TOKEN = "auth/refresh-tokens"
    static CHANGE_PASSWORD_URL = 'users/password'
    static CHANGE_PROFILE_IMAGE = 'users/picture'
    // Staff
    static STAFF_URL = 'staffs'
    static STAFF_CREATE_URL = 'staffs/create'
    // Driver
    static DRIVERS_URL = 'drivers/companies'
    // static ADD_DRIVER_URL = 'drivers'
    static DRIVER_RESET_PASSWORD_URL = 'drivers/resetpassword'
    // Company
    static GET_COMPANIES = 'companies'
    static DISPATCH_CENTER_HISTOR_URL = 'dispatches/company'
    // Trips
    static ASSIGN_TRIPS = 'trips'
    static MEMBER_UPLOAD = 'members/upload'
    static SINGLE_TRIP = 'assigns/singletrip'
    static ASSIGN_EVENTS = 'events'
    static ASSIGN_COMPANY = 'trips/status-update'
    static MARKETPLACE_TRIP = 'trips/marketplace/accept'
    static RESERVE_TRIP = 'trips/marketplace/reserve'
    static STATISTICS = 'trips/lean-kpis'
    // Notification
    static NOTIFICATIONS_URL = 'notifications'
    static NOTIFICATIONS_UNREAD_COUNT = 'notifications/unread-count'
    static NOTIFICATIONS_UNREAD_COUNT_URL = 'notifications/unread-count'
    static NOTIFICATIONS_MARK_ALL_READ = 'notifications/mark-all-read'
    static PUSH_PUBLIC_KEY = 'notifications/push/public-key'
    static PUSH_SUBSCRIBE = 'notifications/push/subscribe'
    static PUSH_UNSUBSCRIBE = 'notifications/push/unsubscribe'
    static PUSH_STATUS = 'notifications/push/status'
    static PUSH_TEST = 'notifications/push/test'
    // Funding Source
    static FUNDING_SOURCE_LIST = 'cooperates'
    static FUNDING_SOURCES = 'fundingsources'
    static DOCUMENTS = 'documents'
    static TRIP_ATTACHMENT = 'upload'
    static SPACETYPES = 'space-types'
    static LEVELOFSERVICE = 'level-of-service'
    static COMPANIES = 'companies'
    static SIGNUPS = 'signup'
    static SERVICE_AREAS = 'service-areas'
    static CREDENTIAL_COMPANIES = 'credentials-companies'
    static All_DRIVERS = 'drivers'
    static COMPANY_DRIVERS = 'drivers/company'
    static CREDENTIAL_VEHICLES = 'credentials-vehicles'
    static VEHICLES = 'vehicles'
    static DRIVERS = 'drivers'
    static COMPANY_VEHICLES = 'vehicles/company'
    // Fares
    static FARES = 'fares'
    static COMPANY_FARRES = 'fares/company'
    static THRESHOLD = 'thresholds'
    // users
    static ADD_USERS = 'auth/register'
    static USERS = 'users'
    static DASHBOARD = 'dashboard'
    static RESET_PASSWORD = 'auth/reset-password'
    static NOTIFICATION = 'notifications'
    static FORGOT_PASSWORD = 'auth/forgot-password'
    static MEMBERS = 'members'
    static APPOINTMENT_TYPES = 'appointment-types'
    static PICKER = '/picker'
    static SEARCH_MEMBERS = 'members/search'
    static COMPANY_CONFIGURATION = 'company-configurations'
    static CONFIG_COMPANY_WISE = 'company-configurations/company'
    static EVENT = 'events'
    static GPS = 'gps'
    static PLACE_TYPES = 'place-types'
    static SEARCH_FUNDING_SOURCES = 'fundingsources/search'
    static ADJUST_TRIPS = 'billings'
    static ADJUST_BILLING_TRIPS = 'fundingsource-billings'
    static SIGNATURE_UPDATE = 'signature'
    static ADDONS = 'addons'
    static RAW_REPORT = 'billings/report'
    static CHANGE_REASON = 'change-reasons'
    static TUTORIALS = 'academy'
    static CONFIGURATIONS = 'configurations'
    static MANUAL_PAYMENTS = 'manual-payments'
    static SUPPORT = 'support'

}